module.exports = {
	effect: 1,
	title: '',
	msg: '',
	headerImg: '',
	icon: '',
	btns: ['close'],
	theme: 'ios7',
	w: null,
	onOpen: null,
	onOpened: null,
	onClose: null,
	onClosed: null,
	hide: false,
	hideMessage:'Don’t show again',
	key: ''
}